import { useBalances } from ".";

import { useVacation } from "../../Policy/hooks";

import { useCurrentCompany } from "hooks/useCurrentCompany";

export const useBalancesTable = ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}) => {
  const companyInfo = useCurrentCompany();

  // Fetching vacation type to get the typeId for fetching vacation balances
  const { data: vacationType, isLoading: isLoadingVacationType } = useVacation({
    colaboraInstanceId: companyInfo?.instanceId,
  });

  const {
    data,
    isLoading: isLoadingBalances,
    refetch,
    ...rest
  } = useBalances({
    typeId: vacationType?.type?.id,
    colaboraInstanceId: companyInfo?.instanceId,
    page,
    pageSize,
  });

  return {
    data,
    isLoading: isLoadingVacationType || isLoadingBalances,
    refetch,
    ...rest,
  };
};
